import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";
import { VKAvverkningskostnadSaveDTO } from "../../dto/avverkningskostnader/avverkningskostnader-dto";
import { AvverkningskostnadAtgard } from "../../models/avverkningskostnader/avverkningskostnader-models";

export class ReplaceAvverkningskostnaderCommand extends BasicCommand<ReplaceAvverkningskostnaderCommand> {

    virkeskopskontraktGUID: string;
    virkeskopsatgardGUID: string;
    mattslag: string;
    avverkningskostnader: VKAvverkningskostnadSaveDTO[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ReplaceAvverkningskostnaderCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "avverkningskostnader";

    get primaryKey(): IPrimaryKey<ReplaceAvverkningskostnaderCommand> {
        return {
            atgardGuid: this.virkeskopsatgardGUID
        };
    }

    constructor(virkeskopskontraktGUID: string, virkeskopsatgardGUID: string, avverkningskostnader: AvverkningskostnadAtgard) {
        super(ReplaceAvverkningskostnaderCommand.$type, ReplaceAvverkningskostnaderCommand.$groupKey, CommandType.Replace);
        this.virkeskopskontraktGUID = virkeskopskontraktGUID;
        this.virkeskopsatgardGUID = virkeskopsatgardGUID;
        this.mattslag = avverkningskostnader.mattslag;
        this.avverkningskostnader = avverkningskostnader.avverkningskostnader.map(k => ({
            id: k.id,
            kostnadBeraknadTotal: k.kostnadBeraknadTotal,
            typ: k.typ,
            kostnadMattslag: k.kostnadMattslag,
            kostnadTotal: k.kostnadTotal
        }));
    }
}
